import { useQuery } from '@tanstack/react-query';
import { CommonKey } from '../../../types/api';
import { insightsUrl } from '../../../utils/apiUrls';

const fetchAutomatedInsights = async ({ clientId, jwt }) => {
    const res = await fetch(`${insightsUrl}/v1/clients/${clientId}/insights`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${jwt}`,
            Accept: 'application/json',
        },
    });

    if (!res.ok) {
        throw new Error('The email and password combination is incorrect');
    }

    const data = await res.json();

    return data;
};

const useAutomatedInsights = ({ user, client }) => {
    const jwt = user?.cubeToken;
    const clientId = client?.id;
    return useQuery({
        queryKey: [CommonKey.AutomatedInsights, clientId],
        queryFn: () => fetchAutomatedInsights({ clientId, jwt }),
    });
};

export default useAutomatedInsights;
